import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from '@angular/core';
import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { CanChangeStoreInReservationPipe } from '@features/reserve-in-store/reserve-in-store-pipes/can-change-store-in-reservation.pipe';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { TooltipComponent } from '@shared/tooltip/tooltip.component';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';

@Component({
    selector: 'app-reserve-in-store-pickup-store',
    templateUrl: './reserve-in-store-pickup-store.component.html',
    styleUrls: ['./reserve-in-store-pickup-store.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgClass,
        SvgIconComponent,
        TooltipComponent,
        AsyncPipe,
        TranslateSafePipe,
        CanChangeStoreInReservationPipe
    ]
})
export class ReserveInStorePickupStoreComponent {
    storeName = input.required<string>();
    storeId = input.required<string>();
    canReserve = input<boolean>();
    allowChangeStore = input<boolean>(false);
    showTooltip = input<boolean>(true);

    @Output() changeStore: EventEmitter<void> = new EventEmitter<void>();
}
